import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { TabView, TabPanel } from "primereact/tabview";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { confirmDialog } from "primereact/confirmdialog";

// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../../Base/Services/ToastService";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { getDateProduction } from "../../../../Base/Services/FechasService";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import Card from "../../../../Base/Components/Card/Card";
import CalendarioOperativo from "../../../../Base/Components/Form/CalendarioOperativo";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";

// ------------------- CONSULTAS A LA API---------------------------
import { getDetallesPartidas, getEncabezadoPartidas } from "../../../../API/Finanzas/RegistroContable/LibroDiarioRequest";
import LibroDiarioCRUD from "./LibroDiarioCRUD";

// ------------------ COMPONENTES DE NECESARIOS--------------------------

const LibroDiarioScreen = () => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);

  const [listadoEnc, setListadoEnc] = useState([]);
  const [listadoDet, setListadoDet] = useState([]);

  const [loading, setLoading] = useState(false);
  const [dates, setDates] = useState([new Date(), new Date()]);
  const [showDialog, setShowDialog] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedEnc, setSelectedEnc] = useState([]);
  const [selectedDet, setSelectedDet] = useState([]);

  const getInfo = async () => {
    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Por favor, seleccione un rango de fechas válido."
      );
      return;
    }
    setLoading(true);
    const fechas = getDateProduction(dates);

    const encabezadoTempo = await getEncabezadoPartidas(fechas);
    setListadoEnc(encabezadoTempo);

    const detallesTempo = await getDetallesPartidas(fechas);
    setListadoDet(detallesTempo);

    setLoading(false);
  };

  const columns = [
    {
      field: "IdPartida",
      header: "ID",
      headerEn: "ID",
      className: "Xsmall",
      frozen: 1,
      hidden: userAuth.IdRol === 1,
    },
    {
      field: "IdReferencia",
      header: "IdRef",
      headerEn: "IdRef",
      className: "Xsmall",
      frozen: 1,
      hidden: userAuth.IdRol === 1,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdReferencia > 0) {
          // openReferencia(data)
        }
      },
    },
    {
      field: "FechaCreado",
      header: "Fecha Creada",
      headerEn: "Date Created",
      frozen: 1,
      className: "Xsmall",
      Format: "Date",
      onCellDoubleClicked: ({ data }) => {
        if (data.IdPartida > 0) {
          setSelectedEnc([data])
          setShowDialog(true)
        }
      },
    },
    {
      field: "NumeroPartida",
      header: "No. Partida",
      headerEn: "Number ",
      className: "Xsmall",
      frozen: 1,
      Sumary: "count",
      Format: "Modal",
      onCellDoubleClicked: ({ data }) => {
        if (data.IdPartida > 0) {
          setSelectedEnc([data])
          setShowDialog(true)
        }
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      frozen: 1,
      className: "Xsmall",
      Format: "Estado",
      body: (rowData) => ({
        ID: rowData.IdEstado,
        Estado: rowData.StatusName,
      }),
    },
    {
      field: "Referencia",
      header: "Referencia",
      headerEn: "Reference",
      className: "medium",
    },
    {
      field: "NumeroReferencia",
      header: "Numero Referencia",
      headerEn: "Reference Number",
      className: "small",
      Format: "Modal",
    },
    {
      field: "PurchaseOrder",
      header: "Orden Compra",
      headerEn: "Purchase Order",
      className: "small",
      Format: "Center",
    },
    {
      field: "Memo",
      header: "Memo",
      flex: 1,
      minWidth: 300,
    },
    {
      field: "TasaCambio",
      header: "Tasa Cambio",
      headerEn: "Converstion Rate",
      className: "Xsmall",
      Format: "Decimal",
    },
    {
      field: "MontoCreditoL",
      header: "Credito L",
      headerEn: "Credit L",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
      editable: userAuth.IdRol === 1,
    },
    {
      field: "MontoDebitoL",
      header: "Debito L",
      headerEn: "Dedit L",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
      editable: userAuth.IdRol === 1,
    },
    {
      field: "IsDiff",
      header: "IsDiff",
      headerEn: "",
      className: "Xsmall",
      hidden: userAuth.IdRol === 1,
      frozen: true,
      alignFrozen: "right",
      Format: "Template",
      body: (data) => (
        <div
          onClick={() => { }}
          onDoubleClick={(e) => { }}
          className="d-flex flex-row"
          style={{ justifyContent: "center", marginTop: 2 }}
        >
          <Checkbox checked={data.IsDiff} aria-disabled />
        </div>
      ),
    },

    {
      field: "Diferencia",
      header: "Diferencia",
      headerEn: "",
      className: "Xsmall",
      Format: "Decimal",
      Sumary: "sum",
      hidden: userAuth.IdRol === 1,
      frozen: true,
      alignFrozen: "right",
    },
    {
      field: 'IdPartida',
      header: '',
      Format: 'Botones',
      frozen: true,
      filter: false,
      alignFrozen: 'right',
      Botones: [
        {
          icon: 'pi pi-pencil',
          tooltip: 'Editar',
          onClick: (rowData) => {
            setSelectedEnc([rowData])
            setShowDialog(true)
          }
        },
        // {
        //   icon: 'ri-file-copy-2-line',
        //   tooltip: getLabel(LibroDiarioLang, 'btnDuplicar', config?.language),
        //   onClick: (rowData) => {
        //     openDialog(rowData.IdPartida, true)
        //   }
        // },
        // {
        //   icon: 'pi pi-times',
        //   tooltip: getLabel(LibroDiarioLang, 'btnAnular', config?.language),
        //   className: 'text-danger',
        //   onClick: (rowData) => {
        //     openAcceso(rowData.IdPartida)
        //   }
        // },
        // {
        //   icon: 'pi pi-print',
        //   tooltip: getLabel(LibroDiarioLang, 'btnReporte', config?.language),
        //   onClick: (rowData) => {
        //     openReporte(rowData.IdPartida)
        //   }
        // },
      ]
    }
  ];

  const table = {
    Columns: columns,
    Data: listadoEnc,
    loading: loading,
    selected: selectedEnc,
    setSelected: setSelectedEnc,
    showModal: () => { },
  };

  const columnsDet = [
    {
      field: "IdMovimiento",
      header: "ID",
      frozen: 1,
      headerEn: "ID",
      className: "Xsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      field: "FechaCreadoEnc",
      header: "Fecha Creada",
      headerEn: "Date Created",
      frozen: 1,
      className: "small",
      Format: "Date",
    },
    {
      field: "NumeroPartida",
      header: "No. Partida",
      frozen: 1,
      className: "Xsmall",
      Format: "Modal",
      onCellDoubleClicked: ({ data }) => {
        if (data.IdPartida) {
          // openDialog(data.IdPartida)
        }
      },
      Sumary: "count",
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      frozen: 1,
      className: "Xsmall",
      Format: "Estado",
      body: (rowData) => ({
        ID: rowData.IdEstado,
        Estado: rowData.StatusName,
      }),
    },
    {
      field: "NumeroReferencia",
      header: "NumeroReferencia",
      headerEn: "NumeroReferencia",
      className: "small",
      Format: "Modal",
    },
    {
      field: "Cuenta",
      header: "Cuenta",
      headerEn: "Cuenta",
      className: "XXXlarge",
    },
    // {
    //     field: 'Area',
    //     header: 'Area',
    //     headerEn: 'Area',
    //     className: 'medium',
    // },
    {
      field: "DebitoL",
      header: "DebitoL",
      headerEn: "DebitoL",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
      editable: userAuth.IdRol === 1,
    },
    {
      field: "CreditoL",
      header: "CreditoL",
      headerEn: "CreditoL",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
      editable: userAuth.IdRol === 1,
    },
    {
      field: "Memo",
      header: "Memo",
      headerEn: "Memo",
      className: "",
      flex: 1,
      minWidth: 300,
    },
    {
      field: "IdMovimiento",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            // openDialog(rowData.IdPartida)
          },
        },
      ],
    },
  ];

  const tableDet = {
    Columns: columnsDet,
    Data: listadoDet,
    loading: loading,
    selected: selectedDet,
    setSelected: setSelectedDet,
    showModal: () => { },
  };

  useEffect(() => {
    getInfo();
    setTitlePage(getLabel(baseLang, "Libro Diario", config.language));
  }, []);

  return (
    <div>
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones flex-wrap">
            <h2>{getLabel(baseLang, "Libro Diario", config.language)}</h2>
            <CalendarioOperativo
              dates={dates}
              setDates={setDates}
              loading={loading}
              getInfo={getInfo}
            />
            <Button
              icon="pi pi-refresh"
              tooltip="Buscar"
              onClick={() => getInfo()}
            />
            <Button
              icon="pi pi-plus"
              tooltip="Nueva"
              onClick={() => {
                setSelectedEnc([])
                setShowDialog(true)
              }}
            />

          </div>
        }
        contenido={
          <div className="pt-4">
            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header="Listado">
                <div style={{ height: "80vh" }}>
                  <AgGrid table={table} />
                </div>
              </TabPanel>

              <TabPanel header="Detalles">
                <div style={{ height: "80vh" }}>
                  <AgGrid table={tableDet} />
                </div>
              </TabPanel>
            </TabView>
          </div>
        }
      />

      {showDialog && (
        <LibroDiarioCRUD
          showDialog={showDialog}
          setShowDialog={setShowDialog}
          selectedEnc={selectedEnc}
          setSelectedEnc={setSelectedEnc}
          getInfo={getInfo}
        />
      )}
    </div>
  );
};

export default LibroDiarioScreen;
